<template>
  <div class="index">
    <el-menu
      default-active="2"
      class="el-menu-vertical-demo el-menu"
      background-color="#409EFF"
      text-color="white"
      router
      active-text-color="white"
    >
      <el-menu-item index="userCenter">
        <i class="el-icon-menu"></i>
        <span slot="title">用户中心</span>
      </el-menu-item>
      <el-submenu index="matchPage">
        <template slot="title">
          <i class="el-icon-menu"></i>
          <span>政策匹配</span>
        </template>
        <el-menu-item index="matchPage?status=0">
          <span slot="title">模糊匹配</span>
        </el-menu-item>
        <el-menu-item index="matchPage?status=1">
          <span slot="title" style="display: flex; align-items: center">
            精准匹配
            <img
              src="../../../../static/vip.png"
              style="width: 20px; height: 20px; margin-left: 5px"
            />
          </span>
        </el-menu-item>
      </el-submenu>
      <el-menu-item index="setPage">
        <i class="el-icon-menu"></i>
        <span slot="title">账号设置</span>
      </el-menu-item>
    </el-menu>
  </div>
</template>

<script>
export default {};
</script>

<style lang="less" scoped>
.index {
  // overflow-x: hidden;
  overflow: hidden;
  .el-menu {
    text-align: left;
    width: 150px;
    .el-submenu {
      width: 150px;
      ::v-deep .el-menu-item {
        width: 150px;
        padding: 0;
        min-width: none;
      }
    }
  }
}
</style>
